<template>
 <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md5>
             <img src="../../assets/images/unoapp.png" class="form-head-logo mb-2"/>
            <v-card class="elevation-12">

              <offset-heading  titleClass="mb-0 headline font-weight-bold" title="RESET PASSWORD" subtitle="Enter your new password."></offset-heading>
              <v-card-text class="nmt-20 mt-7 pt-7">
                <v-form ref="reset-password">
                  <v-text-field
                    v-model="form.password"
                    :rules="fieldRequired"
                    prepend-icon="lock"
                    required
                    validate-on-blur
                    name="New Password"
                    label="New Password"
                    :type="showNewPassword ? 'text' : 'password'"
                    :append-icon="showNewPassword ? 'visibility_off' : 'visibility'"
                    @click:append="showNewPassword = !showNewPassword"
                    >
                  </v-text-field>
                  <v-text-field
                    v-model="form.confirm_password"
                    :rules="fieldRequired"
                    prepend-icon="lock"
                    required
                    validate-on-blur
                    name="Confirm New Password"
                    label="Confirm New Password"
                    :type="showNewPasswordConfirm ? 'text' : 'password'"
                    :append-icon="showNewPasswordConfirm ? 'visibility_off' : 'visibility'"
                    @click:append="showNewPasswordConfirm = !showNewPasswordConfirm"
                  >
                  </v-text-field>
                </v-form>
                <div class="px-5">
                  <v-btn
                    color="primary"
                    fab
                    medium
                    @click="forgot($event)"
                  >
                    <v-icon dark>fas fa-long-arrow-alt-right</v-icon>
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import { mapActions } from 'vuex';
import NormalApi from '@/components/Controllers/NormalApi'; // Just naming as readable
import Helper from '@/components/Controllers/Helpers';
import Env from '@/env';

export default {
  name: 'ResetForgot',
  // data: () => ({
  data() {
    return {
      showNewPassword: false,
      showNewPasswordConfirm: false,
       fieldRequired: [
        v => !!v || 'Field is required',
        v => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}/.test(v) || 'Password must be: min 8 characters and contain 1 number and 1 capital letter.',
      ],
      form: {
        password: '',
        confirm_password: '',
      },
    };
  },
  props: {
    source: String,
  },
  mounted() {
    if( this.$route.query.token ){
      this.validateToken(this.$route.query.token);
    } else {
      this.$router.push({ name: 'Login' });
    }
  },

  methods: {
    /**
     * Validate Token
     */
    validateToken(token) {
      const url = `${Env.url}/api/v1/users/password/reset/${token}`;
      this.spinner(true);
      NormalApi.getApi(url, {
        'api-token': Env.apiToken 
      }, this.form)
        .then((res) => {
          this.spinner(false);
        })
        .catch(() => {
          this.snackbar({
            text: 'Invalid token.',
            timeout: 3000,
            open: true,
          });
          this.$router.push({ name: 'Login' });
          this.spinner(false);
        })
    },


    /**
     * Handles the forgot password email submisstion
     */
    forgot() {
      if (this.$refs['reset-password'].validate()) {
        if(this.form.password === this.form.confirm_password){
          this.spinner(true);
          const url = `${Env.url}/api/v1/users/password/reset/${this.$route.query.token}`;
          NormalApi.postApi(url, {
            'api-token': Env.apiToken 
          }, this.form)
          .then((res) => {
            this.snackbar({
              text: 'Successfully updated. Please login',
              timeout: 3000,
              open: true,
            });
            this.$router.push({ name: 'Login' });
          })
          .catch((err) => {
            this.spinner(false);
            this.snackbar({
              text: 'This reset request is no longer valid.',
              timeout: 3000,
              open: true,
            });
          });
          this.$router.push({ name: 'Login' });
        } else {
          this.snackbar({
            text: 'Password mismatch.', 
            timeout: 3000,
            open: true,
          });
        }
      }
    },
    ...mapActions({
      snackbar: 'snackbar/snackbar',
      spinner: 'spinner/spinnerStatus',
    }),
  },
};
</script>

